export default __webpack_public_path__ + "static/media/candlestick-chart-icon.aeb862a6.svg";